import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Grid, Typography } from '@mui/material';

function IgnoreInstructions({ device }) {
  const { t } = useTranslation();
  const { ignorable } = useSelector((state) => state.status);

  const renderIgnoreText = () => {
    switch (device) {
      case 'camera':
        return (
          <>
            {t('You can choose to ignore this and proceed without a camera.')}{' '}
            {t(
              'Doing so means that other participants will not see you in the meeting.'
            )}
          </>
        );
      case 'microphone':
        return (
          <>
            {t(
              'You can choose to ignore this and proceed without a microphone.'
            )}{' '}
            {t(
              'Doing so means that other participants will not hear you in the meeting.'
            )}
          </>
        );
      case 'speaker':
        return (
          <>
            {t('You can choose to ignore this and proceed without a speaker.')}{' '}
            {t(
              'Doing so means that you will not be able to hear other participants in the meeting.'
            )}
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      {ignorable && (
        <Grid item>
          <Typography>{renderIgnoreText()}</Typography>
        </Grid>
      )}
    </>
  );
}

export default IgnoreInstructions;
